import type { SVGProps } from "react";
export interface VectorCircleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function VectorCircleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: VectorCircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.085 13.728a7.14 7.14 0 0 0 4.698 5.045l.469.136.11.034a1.126 1.126 0 0 1-.548 2.17l-.113-.023-.618-.178a9.39 9.39 0 0 1-6.18-6.64L3.994 14zm13.829 0a1.126 1.126 0 0 1 2.184.543 9.39 9.39 0 0 1-6.799 6.82l-.114.023a1.126 1.126 0 0 1-.437-2.205l.47-.136a7.14 7.14 0 0 0 4.696-5.045m-15.192-.82a1.126 1.126 0 0 1 1.363.82l-2.182.543a1.125 1.125 0 0 1 .819-1.363M9.728 2.903a1.125 1.125 0 0 1 .545 2.182 7.14 7.14 0 0 0-5.188 5.187 1.125 1.125 0 0 1-2.182-.545 9.39 9.39 0 0 1 6.825-6.824m3.18.819c.15-.603.76-.97 1.364-.82a9.39 9.39 0 0 1 6.648 6.206l.178.62.022.114a1.125 1.125 0 0 1-2.173.54l-.033-.11-.134-.471a7.14 7.14 0 0 0-5.052-4.716 1.126 1.126 0 0 1-.82-1.363"
      />
      <path
        fill={color}
        d="M12.875 20a.875.875 0 1 0-1.75 0 .875.875 0 0 0 1.75 0m-8-8a.876.876 0 1 0-1.75 0 .876.876 0 0 0 1.75 0m16 0a.875.875 0 1 0-1.751 0 .875.875 0 0 0 1.75 0Zm-8-8a.875.875 0 1 0-1.75 0 .875.875 0 0 0 1.75 0m2.25 16a3.125 3.125 0 1 1-6.25 0 3.125 3.125 0 0 1 6.25 0m-8-8a3.126 3.126 0 1 1-6.251-.002A3.126 3.126 0 0 1 7.125 12m16 0a3.125 3.125 0 1 1-6.25 0 3.125 3.125 0 0 1 6.25 0m-8-8a3.126 3.126 0 1 1-6.252 0 3.126 3.126 0 0 1 6.252 0"
      />
    </svg>
  );
}
